<script setup lang="ts">
// Root component stays thin: auth initialization is handled in main.ts
// before app mount, so no side effects are needed here.
</script>

<template>
  <router-view />
</template>
